<template>
  <div v-if="this.identity !== ''">
    <!-- 导航栏 -->
    <el-menu
      :default-active="activeIndex"
      style="display: flex; justify-content: center; align-items: center"
      mode="horizontal"
      background-color="#000"
      text-color="#fff"
      active-text-color="#2593fc"
      router
    >
      <div style="font-size: 25px; color: #fff; margin-right: 10px">爱批改</div>
      <el-menu-item
        index="tasks"
        v-if="
          (this.identity.indexOf('teacher') >= 0 &&
              (this.teacherGroup  === 2  ||  this.teacherGroup === 4 || this.teacherGroup === 8 || (((this.teacherGroup & 1) === 1) && ((this.teacherGroup & 16) === 16) && this.role === 1))) || this.identity.indexOf('auditor') >= 0
        "
        >任务领取</el-menu-item
      >
      <el-menu-item index="myTasks">我的任务</el-menu-item>
      <div style="width: 30%"></div>
      <div style="margin: 0 30px 0 10px; font-size: 13px; color: #999">
        {{ userName }}, 欢迎您!
      </div>
      <el-menu-item index="user">个人中心</el-menu-item>
      <!-- <el-menu-item index="4">作文批改</el-menu-item> -->
      <div>|</div>
      <el-menu-item><span @click="clearCache()">退出</span></el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import jwt_decode from "jwt-decode";

export default {
  props: {
    userName: String,
    activeIndex: String,
    identity: String,
    teacherGroup: Number,
    role: Number,
  },
  data() {
    return {
      // 存放变量
      // teacherGroup: 0,
      // identity: "",
    };
  },
  mounted() {},
  created() {},
  methods: {
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      localStorage.removeItem("role");  // 清空localStorage中的缓存
      this.$router.push({ path: "/login" });
    }
  }
};
</script>
<style scoped></style>
